<div [hidden]="versionShareBubbles.length == 0" class="version-details-feedback">
  <ul>
    <li *ngFor="let versionShare of versionShareBubbles">
      <core-version-shares-item
        [shareItem]="versionShare"
        [menu]="menu"
        (menuClick)="onMenuItemClick($event)"
      ></core-version-shares-item>
    </li>
  </ul>
</div >